import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import {
  buildWorkOrderStockIssueCreatePayload,
} from '#/api/momMgmt/workOrder/outbound/serializeOutboundWrite';

/**
 * 工單巢狀出庫 create（`mom.work_order.stock_issue.create`）。
 * POST `/mom/work-order/{workOrderId}/stock-issue`
 *
 * @param {string} workOrderId
 * @param {object} values
 */
export async function createWorkOrderStockIssue(workOrderId, values) {
  const { data: raw } = await request.post(
    `/mom/work-order/${workOrderId}/stock-issue`,
    keysToSnake(buildWorkOrderStockIssueCreatePayload(values)),
  );
  return parseVer4DetailResponse(raw);
}
